import { Injectable } from "@angular/core";

export interface SubMenu {
  state: string;
  name: string;
  type: string;
  icon: string;
  priv: string;
}
export interface Menu {
  state: string;
  name: string;
  type: string;
  icon: string;
  priv: string;
  children: SubMenu[];
}

const MENUITEMS = [
  {
    state: "voyage",
    type: "link",
    name: "voyageList",
    icon: "commute",
    priv: "rd_voyage",
    children: [],
  },
  {
    state: "passagerlist",
    type: "link",
    name: "passagerList",
    icon: "groups",
    priv: "rd_passager",
    children: [],
  },
  {
    state: "reservation",
    type: "link",
    name: "reservationList",
    icon: "perm_contact_calendar",
    priv: "rd_reservation",
    children: [],
  },
  {
    state: "bagage/autre",
    type: "link",
    name: "autresentre",
    icon: "all_inclusive",
    priv: "cr_recette",
    children: [],
  },
  {
    state: "free",
    type: "link",
    name: "freecode",
    icon: "shuffle",
    priv: "rd_freeticket",
    children: [],
  },
  {
    state: "passengertravel",
    type: "link",
    name: "loyalty",
    icon: "library_add",
    priv: "rd_loyalty",
    children: [],
  },
  {
    state: "collis/mail",
    type: "link",
    name: "listcollis",
    icon: "view_list",
    priv: "rd_colis",
    children: [],
  },
  {
    state: "session/usersession",
    type: "link",
    name: "raportsessions",
    icon: "insights",
    priv: "cr_voyage",
    children: [],
  },
  {
    state: "session",
    type: "link",
    name: "raportsession",
    icon: "update",
    priv: "rd_session",
    children: [],
  },
  {
    state: "raport",
    type: "link",
    name: "raport",
    icon: "update",
    priv: "rd_session",
    children: [],
  },
];

@Injectable()
export class MenuItemsChef {
  getMenuitem(): Menu[] {
    return MENUITEMS;
  }
}
